export const translateStatus = {
  incomplete: 'Incompleto',
  complete: 'Completo'
};

export const markingTypes = [
  { label: 'Entrada Jornada', value: 0 },
  { label: 'Salida Jornada', value: 1 },
  { label: 'Entrada Colación', value: 2 },
  { label: 'Salida Colación', value: 3 }
];

export const statuses = [
  { label: 'Incompleto', value: 'incomplete' },
  { label: 'Completo', value: 'complete' }
];
